import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.js";
import { installPerfBridge } from "./perf/perf-bridge.js";
import { installTestCaptureBridgeIfEnabled } from "./shell/lib/test-capture-bridge.js";
import { initAnalytics } from "./game/analytics.js";
import { FatalBoundary } from "./shell/ui/FatalBoundary.js";
import { installFaultConsole } from "./shell/lib/fault.js";

installTestCaptureBridgeIfEnabled();
// Survive editor→publish navigation so capture lifecycle stays readable.
installPerfBridge();
// No-op unless explicitly configured + enabled (see game/analytics.ts) —
// dev/tests/unconfigured deploys make zero network calls.
initAnalytics();
// Faults are readable from a live session via `__deskFaults()` in the console.
installFaultConsole();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <FatalBoundary>
      <App />
    </FatalBoundary>
  </StrictMode>,
);
